const getters = {
  getRuns: (state) => state.runs,
  getRunById: (state) => (id) => state.runs.find((x) => x.id === id),
  getResultsViewForCurrentRun: (state) => state.current.resultsView,
}
export default getters;
